import React, { useState, useEffect } from "react";
import { setReminderOndemand } from "../../../services/medium";
import { toast } from "react-toastify";
import moment from "moment";
import { useSelector } from "react-redux";
import { use } from "react";
import "./goondemand.css";
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from "react-i18next";
import { useDynamicTranslation } from "../../../i18n/dynamicContent";
export default function BookingConfirmPopUp({
  userDetails,
  slotDetails,
  continueBrowsing,
  directAppMediumInfo
}) {
  const { first_name } = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const { t } = useTranslation("mediumPracticePopups");
  const { formatDate } = useDynamicTranslation();
  useEffect(() => {
     console.log(directAppMediumInfo, "directAppMediumInfo");
    }, [directAppMediumInfo]);
const { medium_name = "", fullday = "", backupdate = '', title = "", ondemand_session_category_id,subtext = "" } = directAppMediumInfo
const goToAppointments = () => {
  // Optionally hide the modal first
   window.loadModal2("#BookingConfirmPopUp", "hide");

  // 2. Remove modal-related classes and backdrops after small delay
  setTimeout(() => {
    document.body.classList.remove("modal-open"); // remove body lock
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.remove(); // remove dark overlay

    // 3. Navigate
    navigate("/appointments");
  }, 200);
};
  return (
    <div>
      <div
        id="BookingConfirmPopUp"
        class="modal fade bd-example-modal-lg maj-5 preview-modal-availability"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      // data-backdrop="static"
      >
        <div class="modal-dialog modal-lg modal-dialog-preview text-center">
          <div class="modal-content p-5 ">
            <div className="cross-icon-popup">

            </div>

            <div className="paymymedium-container">
              <div className="">
                <img src="../images/new-cll.png" alt="user" />
                <>
                  <h3 className="mt-3">
                    {t("bookingConfirm.title")}
                    {/* {userDetails && userDetails.first_name}, your appointment is
                      confirmed */}
                  </h3>
                  <div className="font-size-17 advance-guest-book-p">
                    {t("bookingConfirm.checkEmail")}
                  </div>
                </>
                <h5 className="mt-2">
                  {console.log(userDetails.first_name, "userDetails.first_name")}
                  {t("bookingConfirm.confirmedFor", { name: userDetails && userDetails.first_name !== undefined ? userDetails.first_name : first_name })}
                </h5>
                {/* <span className="advance-guest-book-span"> */}
                  {/* {slotDetails &&
                    moment(
                      `${slotDetails.date} ${slotDetails.time}`,
                      "YYYY-MM-DD hh:mm A"
                    ).format("hh:mm A")}{" "} */}
                  {/*  <br/>
                                  <p className="advance-guest-book-p">
                                    {slotDetails &&
                                      moment(
                                        `${slotDetails.date} ${slotDetails.time}`,
                                        "YYYY-MM-DD hh:mm A"
                                      ).format("hh:mm A")}{" "}
                                  </p>
                                  <br />
                {/* </span> */}
                {/* <br /> */}
                <p className="advance-guest-book-p bottom-gap-6">
                  {slotDetails &&
                    formatDate(
                      moment(`${slotDetails.date}`, "YYYY-MM-DD hh:mm A").toDate(),
                      { weekday: "long", month: "long", day: "numeric", year: "numeric" },
                      `${slotDetails.day_of_week},\u00a0${moment(`${slotDetails.date}`, "YYYY-MM-DD hh:mm A").format("LL")}`
                    )}{" "}
                </p>
                <br />
             
                <p className="advance-guest-book-p bottom-gap-6">
                  {slotDetails &&
                    moment(
                      `${slotDetails.date} ${slotDetails.time}`,
                      "YYYY-MM-DD hh:mm A"
                    ).format("hh:mm A")}{" "}
                </p>
               
                 {ondemand_session_category_id != "95" && ondemand_session_category_id != "101" && (
                    <>
                       <br />
                      <p className="advance-guest-book-p bottom-gap-6 size-33">
                    <Trans i18nKey="bookingConfirm.withMedium" ns="mediumPracticePopups" values={{ name: slotDetails && slotDetails.medium_name }} components={{ b: <b /> }} />
                      </p>
                      </>
                      
                    )}
                
                {/* <span className="advance-guest-book-span">
                        {" "}
                        An account has been created on VerySoul.com.
                        <br /> Please check your email for a temporary password to Login.
                      </span> */}
                {/* <div>
            
                  <a className="advance-tag-my-calendar"
                    target="_blank"
                    href={slotDetails && slotDetails.calendarLink}
                  >
                    Add to my calendar
                  </a>
                </div> */}

              </div>
            </div>

            <form className="mtop-5" id="msform">
              <div className="mt-2 ml-4 mr-4 d-flex flex-column flex-md-row justify-content-center align-items-center  button-gap-new">


                <div>
                  <button
                    type="button"
                    
                    onClick={goToAppointments}
                    className="next action-button float-right margin-unset"
                  >
                    {t("bookingConfirm.myAppointments")}
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    onClick={continueBrowsing}
                    className="previous action-button-previous float-left width-unset pl-4 pr-4 mr-5 color-d5a67b color-d5a67b-qw"
                  >
                    {t("bookingConfirm.continueBrowsing")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
